import { createIcon } from "@chakra-ui/react";

export const Pass = createIcon({
  displayName: "Pass",
  viewBox: "0 0 24 24",
  path: [
    <path
      fill="#FFBC58"
      d="M2.625 12a9.376 9.376 0 1 0 18.751 0 9.376 9.376 0 0 0-18.751 0zm4.742 2.992a.31.31 0 0 1 .078-.433.309.309 0 0 1 .434.078C8.695 15.797 10.07 17 12 17c1.93 0 3.305-1.203 4.117-2.367a.313.313 0 0 1 .434-.078c.14.097.176.293.078.433-.875 1.254-2.414 2.637-4.629 2.637-2.215 0-3.754-1.383-4.633-2.633zm2.149-4.867a.625.625 0 1 1-1.25 0 .625.625 0 0 1 1.25 0zm6.25 0a.625.625 0 1 1-1.25 0 .625.625 0 0 1 1.25 0z"
    />,
    <path
      fill="#2B2C3D"
      d="M21.375 12a9.376 9.376 0 1 0-18.752 0 9.376 9.376 0 0 0 18.752 0zM2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0zm5.883 2.633C8.695 15.797 10.07 17 12 17c1.93 0 3.305-1.203 4.117-2.367a.313.313 0 0 1 .434-.078c.14.097.176.293.078.433-.875 1.254-2.414 2.637-4.629 2.637-2.215 0-3.754-1.383-4.633-2.633a.31.31 0 0 1 .078-.433.309.309 0 0 1 .434.078l.004-.004zm.383-4.508a.625.625 0 1 1 1.25 0 .625.625 0 0 1-1.25 0zM15.14 9.5a.625.625 0 1 1 0 1.25.625.625 0 0 1 0-1.25z"
    />,
  ],
  defaultProps: {
    "aria-label": "Smiling face emoji"
  }
});

export default Pass;
